import * as React from 'react';
import { ThemeContext } from '@emotion/core';
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming';
import FocusVisible from "./FocusVisible";
import theme from "./theme.js";

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(EmotionThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(FocusVisible, null), children);
};

ThemeProvider.defaultProps = {
  theme: theme
};

var useTheme = function useTheme() {
  var theme = React.useContext(ThemeContext);

  if (theme === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }

  return theme;
};

export default ThemeProvider;
export { useTheme, ThemeProvider, ThemeContext };